/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_UncoveredInputs */

const en_queue_sos_uncovered = /** @type {(inputs: Queue_Sos_UncoveredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders locked without cover`)
};

/**
* | output |
* | --- |
* | "Sales orders locked without cover" |
*
* @param {Queue_Sos_UncoveredInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_uncovered = /** @type {((inputs?: Queue_Sos_UncoveredInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_UncoveredInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_uncovered(inputs)
});